import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { useEffect, useRef, type ReactElement } from 'react';

const DEFAULT_AUTO_DISMISS_MS = 6_000;

export type ChatErrorAlertProps = {
    message: string | null;
    onDismiss: () => void;
    autoDismissMs?: number;
};

export function ChatErrorAlert({
    message,
    onDismiss,
    autoDismissMs = DEFAULT_AUTO_DISMISS_MS,
}: ChatErrorAlertProps): ReactElement {
    const onDismissRef = useRef(onDismiss);
    onDismissRef.current = onDismiss;

    useEffect(() => {
        if (message === null) {
            return;
        }
        const timeoutId = window.setTimeout(() => onDismissRef.current(), autoDismissMs);
        return (): void => window.clearTimeout(timeoutId);
    }, [message, autoDismissMs]);

    return (
        <Collapse in={message !== null} unmountOnExit>
            <Alert severity="error" onClose={onDismiss}>
                {message}
            </Alert>
        </Collapse>
    );
}
